var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('BaseHeaderBar',{attrs:{"title":"Perjanjian Pinjaman","showCustomerService":false,"showBackButton":true}}),_c('iframe',{attrs:{"src":_vm.frameSrc,"frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }